import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCardModule, MatMenuModule, MatToolbarModule, MatIconModule, MatSidenavModule, MatDatepickerModule, MatNativeDateModule, MatInputModule, MAT_DATE_LOCALE, MatOptionModule, MatSelectModule, MatAutocompleteModule, MatTableModule, MatProgressSpinnerModule, MatTooltipModule, MatDialogModule, MatPaginatorModule, MatChipsModule, MatCheckboxModule } from '@angular/material';
import { MenuComponent } from './menu/menu.component';
import { LoginComponent } from './login/login.component';
import { AdministracaoComponent } from './administracao/administracao.component';
import { ClientesComponent } from './clientes/clientes.component';
import { CadastroClienteComponent } from './cadastro-cliente/cadastro-cliente.component';
import { CadastroUsuarioComponent } from './cadastro-usuario/cadastro-usuario.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { BuscaDocumentosComponent } from './busca-documentos/busca-documentos.component';
import { CadastroTipoDocumentoComponent } from './cadastro-tipo-documento/cadastro-tipo-documento.component';
import { TiposDocumentoComponent } from './tipos-documento/tipos-documento.component';

// providers
import { SessionService } from '../providers/session.service';
import { ClienteService } from '../services/cliente.service';
import { TokenInterceptor } from '../services/httpinterceptor.service';
import { AlertService, DialogOverviewExampleDialog } from '../providers/alert.service'
import { ConfigsService } from '../providers/configs.service'
import { UsuarioService } from '../services/usuario.service'
import { ExcluirDocumentoComponent } from './excluir-documento/excluir-documento.component';
import { ExcluirClienteComponent } from './excluir-cliente/excluir-cliente.component';
import { ExcluirTipoComponent } from './excluir-tipo/excluir-tipo.component';
import { ExcluirUsuarioComponent } from './excluir-usuario/excluir-usuario.component';
import { TrocaSenhaComponent } from './troca-senha/troca-senha.component';
import { PdfViewComponent } from './pdf-view/pdf-view.component';

//outros plugins
import { TextMaskModule } from 'angular2-text-mask';
import { FileUploadModule } from 'ng2-file-upload';
import { NgxLoadingModule } from 'ngx-loading';
import { PdfViewerModule } from 'ng2-pdf-viewer';


@NgModule({
	declarations: [
		AppComponent,
		MenuComponent,
		LoginComponent,
		AdministracaoComponent,
		ClientesComponent,
		CadastroClienteComponent,
		UsuariosComponent,
		CadastroUsuarioComponent,
		BuscaDocumentosComponent,
		FileUploadComponent,
		CadastroTipoDocumentoComponent,
		DialogOverviewExampleDialog,
		TiposDocumentoComponent,
		ExcluirDocumentoComponent,
		ExcluirClienteComponent,
		ExcluirTipoComponent,
		ExcluirUsuarioComponent,
		TrocaSenhaComponent,
		PdfViewComponent 
	],
	entryComponents: [
		DialogOverviewExampleDialog,
		ExcluirDocumentoComponent,
		ExcluirClienteComponent,
		ExcluirTipoComponent, 
		ExcluirUsuarioComponent 
		
    ],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		MatButtonModule,
		MatCardModule,
		MatMenuModule,
		MatToolbarModule,
		MatIconModule,
		MatSidenavModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatInputModule,
		MatOptionModule,
		MatSelectModule,
		MatAutocompleteModule,
		MatTableModule,
		MatProgressSpinnerModule,
		MatTooltipModule,
		MatDialogModule,
		MatPaginatorModule,
		MatChipsModule,
		MatCheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		TextMaskModule,
		HttpClientModule,
		FileUploadModule,
		NgxLoadingModule,
		PdfViewerModule,
	],
	providers: [
		SessionService,
		AlertService,
		ConfigsService,
		ClienteService,
		UsuarioService,
		{
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
	],
	bootstrap: [AppComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
